// client/src/utils/bracketCalculations.js

/**
 * Bracket calculation utilities
 *
 * Provides mathematical utilities for tournament bracket calculations,
 * including power-of-two sizing and bracket information.
 */

/**
 * Get the next power of two greater than or equal to a number
 * Used to determine bracket size (brackets must be powers of 2)
 * @param {number} num - Number to round up to next power of two (negative values return 2)
 * @returns {number} Next power of two (minimum 2)
 */
export function getNextPowerOfTwo(num) {
  if (num <= 1) return 2
  return Math.pow(2, Math.ceil(Math.log2(num)))
}

/**
 * Get bracket information for a league
 * Calculates bracket size and number of byes based on eligible players
 * @param {Array} players - Array of player objects with division_id property (null for unassigned players)
 * @param {Object} selectedLeague - Currently selected league object (optional, for future use)
 * @returns {Object|null} Object with participantsCount, bracketSize, and numByes, or null if no league
 */
export function getBracketInfo(players, selectedLeague) {
  if (!selectedLeague) return null

  // Count players with standings (those who played matches)
  const participantsCount = players.filter((p) => p.division_id !== null).length
  const bracketSize = getNextPowerOfTwo(participantsCount)
  const numByes = bracketSize - participantsCount

  return {
    participantsCount,
    bracketSize,
    numByes,
  }
}
